define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    exports["default"] = {
        fabricId: 740,
        fabricCodeName: 'CL-GY201-10'
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/fallbackMatchingFabric.js
// module id = 48
// module chunks = 0